import { ProductDetails } from './ProductDetails'

export { ProductDetails }
export default ProductDetails
